
export class Screenshot {
  path: string;
  title: string;
  subTitle: string;
  alt: string;
}
